import { Link, createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { Alert, Card } from "../components/ui";
import { useT } from "../i18n/I18nProvider";

/** Better Auth redirects here (errorURL) when a browser flow such as OAuth fails. */
export const Route = createFileRoute("/auth/error")({
  validateSearch: z.object({ error: z.string().optional() }),
  component: AuthErrorPage,
});

function AuthErrorPage() {
  const t = useT();
  const { error } = Route.useSearch();
  return (
    <main className="mx-auto w-full max-w-md px-4 py-10">
      <Card title={t("auth.error.title")}>
        <Alert kind="error">{t("auth.error.body", { code: error ?? "unknown" })}</Alert>
        <p className="mt-4 flex flex-col gap-1 text-sm">
          <Link to="/login">{t("nav.signIn")}</Link>
        </p>
      </Card>
    </main>
  );
}
